import { generatePath } from 'react-router-dom';
import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import { CloverDevice } from 'types';
import { apiQuery } from 'store/query';
import { addParamsToUrl } from 'utils/query';

import {
  ListRequest,
  CreateCloverDeviceRequest,
  UpdateCloverDeviceRequest,
} from './types';

export const tagTypes = ['Clover Device'];

export const cloverDeviceApi = createApi({
  tagTypes,
  baseQuery: apiQuery,
  reducerPath: 'cloverDeviceApi',
  endpoints: (build) => ({
    delete: build.mutation<void, any>({
      invalidatesTags: tagTypes,
      query: (id) => ({
        method: 'delete',
        url: generatePath(URL.GET_CLOVER_DEVICE, { id }),
      }),
    }),

    details: build.query<CloverDevice, string>({
      providesTags: tagTypes,
      query: (id) => ({
        method: 'get',
        url: generatePath(URL.GET_CLOVER_DEVICE, { id }),
      }),
    }),

    create: build.mutation<CloverDevice, CreateCloverDeviceRequest>({
      invalidatesTags: tagTypes,
      query: (data) => ({
        data,
        method: 'post',
        url: URL.GET_CLOVER_DEVICES,
      }),
    }),

    list: build.query<CloverDevice[], ListRequest | void>({
      providesTags: tagTypes,
      query: (params) => ({
        method: 'get',
        url: addParamsToUrl(URL.GET_CLOVER_DEVICES, params || {}),
      }),
    }),

    update: build.mutation<CloverDevice, UpdateCloverDeviceRequest>({
      invalidatesTags: tagTypes,
      query: ({ id, ...data }) => ({
        data,
        method: 'patch',
        url: generatePath(URL.GET_CLOVER_DEVICE, { id }),
      }),
    }),
  }),
});

export const {
  useListQuery,
  useDetailsQuery,
  useCreateMutation,
  useUpdateMutation,
  useDeleteMutation,
} = cloverDeviceApi;
